export default __webpack_public_path__ + "static/media/pdficon.219678de.svg";